import css from "./memory.module.scss";

const VARIANTS = {
  primary: css.btnPrimary,
  ghost: css.btnGhost,
  quiet: css.btnQuiet,
  danger: css.btnDanger,
  dangerSolid: css.btnDangerSolid,
};
const SIZES = {
  md: css.btnMd,
  mdPlain: css.btnMdPlain,
  sm: css.btnSm,
  xs: css.btnXs,
};

/**
 * The one button in the memory panel. Native <button> rather than Mantine so
 * the pill, the nested trailing glyph and the press physics are ours; the
 * label always stays rendered so the accessible name never changes mid-action.
 */
export default function MemoryButton({
  variant = "quiet",
  size = "sm",
  icon,
  trailing,
  loading = false,
  disabled = false,
  className = "",
  children,
  ...rest
}) {
  const shape = trailing
    ? SIZES[size]
    : SIZES[size === "md" ? "mdPlain" : size];
  return (
    <button
      type="button"
      disabled={disabled || loading}
      className={[css.btn, shape, VARIANTS[variant], className]
        .filter(Boolean)
        .join(" ")}
      {...rest}
    >
      {loading ? (
        <span className={css.spinner} aria-hidden="true" />
      ) : (
        icon && (
          <span className={css.btnLead} aria-hidden="true">
            {icon}
          </span>
        )
      )}
      {children != null && <span>{children}</span>}
      {trailing && (
        <span className={css.btnTrail} aria-hidden="true">
          {trailing}
        </span>
      )}
    </button>
  );
}
